import backArrow from "./back-arrow.png";
import frontArrow from "./front-arrow.png";

const icons = {
    backArrow,
    frontArrow,
};

export default icons;
